// extracted by mini-css-extract-plugin
export default {"root":"FilterPopup_root__Yfglr","popup":"FilterPopup_popup__6Rfm+","popupSize":"FilterPopup_popupSize__KFxI1","isOpen":"FilterPopup_isOpen__4dkTE"};